export const TEMPLATE_TAGS = {
    education: 'education',
    business: 'business',
}
